export const baseUrl: string = "https://chg-mall.ru";
export const mobileResolution = '500w'
export const pcResolution = '1920w'
